module.exports = __webpack_public_path__ + "img/onboarding-step-8.61a3883d.png";